import { useNavigate, useParams } from "react-router-dom";
import EditView from "@features/tools/view/interactive-materials-view/single-interactive-material-view/edit";

const EditInteractiveMaterial = () => {
  const { id } = useParams<{ id: string }>();
  const navigate = useNavigate();

  const handleFinish = () => {
    navigate(`/content/interactive-materials/${id}`);
  };

  return <EditView id={id!} onFinish={handleFinish} />;
};

export default EditInteractiveMaterial;
